import { Button, Stack, Title } from '@mantine/core'
import { Link, useParams } from '@tanstack/react-router'
import { TwContainer } from '@/lib/components/TwContainer'

export const HivSectionOne = () => {
	const { location } = useParams({ strict: false })
	return (
		<section
			style={{
				backgroundImage: 'url(/images/img_12.webp)',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				minHeight: '480px',
			}}
			className={'h-96'}
		>
			<TwContainer className={'justify-center items-center'} fill>
				<Stack className={'max-w-2xl my-auto'} align={'center'}>
					<Title className={'text-center md:text-left'} variant={'cyan'} fz={18}>
						Welcome to
					</Title>
					<Title variant={'title'}>Wellview Care</Title>
					<Title variant={'title'}>
						HIV Treatments In{' '}
						{location === 'Fort-Lauderdale' ? 'Fort Lauderdale' : location === 'Riviera-Beach' ? 'Riviera Beach' : 'Southeast Florida'}
					</Title>
					<Button size={'xl'} className={'rounded-xl px-12'} component={Link} to={'/contact'} mt={16} color={'brand.9'}>
						Get In Touch
					</Button>
				</Stack>
			</TwContainer>
		</section>
	)
}
